// @ts-nocheck

/**
 * * `pending` - pending
 * `generating` - generating
 * `ready` - ready
 * `failed` - failed
 * `no_children` - no_children
 */
export type AvatarStatusEnum =
  typeof AvatarStatusEnum[keyof typeof AvatarStatusEnum];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const AvatarStatusEnum = {
  pending: "pending",
  generating: "generating",
  ready: "ready",
  failed: "failed",
  no_children: "no_children",
} as const;
